// src/components/SimpleFormComponents/SimpleEntityPersonFormBR.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import SimpleEntityUid from '../../SimpleEntityUid';
import SimpleInput from '../../SimpleInput';
import SimplePhone from '../../SimplePhone';
import SimpleEmail from '../../SimpleEmail';
import SimpleGender from 'components/SimpleComponents/SimpleGender';
import SimpleBirthdate from 'components/SimpleComponents/SimpleBirthdate';
import useSubscriptionLocale from 'hooks/useSubscriptionLocale';
import { countryCodeFromLocale } from '../../SimpleEntityUid';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleEntityPersonFormBR = ({
  style = {},
  subdocumentField,
  personPhoneProfile,
  countryCode: countryCodeProp,
  unique, // unique person by cpf/nif/ssn
  searchCpfByApi = false, // If true, search external APIs for auto-fill

  showCpfField = true,
  cpfFieldFirst = true,
  useInModal = false,
}) => {
  const { locale } = useSubscriptionLocale();
  const countryCode = countryCodeProp || countryCodeFromLocale(locale);
  // ---------------------------------------------------------------------------
  // PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES I
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <>
      <Row gutter={ROW_GUTTER} style={style}>
        {/* TAX ID FIELD - Universal (CPF/NIF/SSN/UID based on country) */}
        {showCpfField && (
          <Col xs={24} sm={12} lg={6} order={cpfFieldFirst ? 1 : 2}>
            <SimpleEntityUid
              entityType="person"
              countryCode={countryCode}
              searchCnpjByApi={searchCpfByApi}
              unique={unique}
              subdocumentField={subdocumentField}
            />
          </Col>
        )}

        {/* PREFERRED NAME */}
        <Col xs={24} sm={12} lg={6} order={cpfFieldFirst ? 2 : 1}>
          <SimpleInput
            name="name"
            subdocumentField={subdocumentField}
            label="name"
            repeatOnField="fullName"
            useInitialInAvatar
            tooltip="preferred_or_social_name"
          />
        </Col>

        {/* FULL NAME */}
        <Col xs={24} sm={24} lg={12} order={3}>
          <SimpleInput name="fullName" label="full_name" subdocumentField={subdocumentField} />
        </Col>
      </Row>

      <Row gutter={ROW_GUTTER}>
        {/* UNIQUE KEY PREFERRED: EMAIL */}
        <Col xs={24} sm={12} lg={useInModal ? 8 : 6}>
          <SimpleEmail
            name={['email', 'value']}
            label="email"
            subdocumentField={subdocumentField}
          />
        </Col>

        {/* PHONE AS SECONDARY IDENTIFIER */}
        <Col xs={24} sm={12} lg={useInModal ? 8 : 6}>
          <SimplePhone
            name={['phone', 'value']}
            label="phone"
            international
            profile={personPhoneProfile}
            countryCode={countryCode}
          />
        </Col>

        <Col xs={24} sm={12} lg={useInModal ? 8 : 6}>
          <SimpleBirthdate
            name="birthdate"
            subdocumentField={subdocumentField}
            entityType="person"
          />
        </Col>

        <Col xs={24} sm={12} lg={useInModal ? 8 : 6}>
          <SimpleGender name="gender" subdocumentField={subdocumentField} />
        </Col>
      </Row>
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleEntityPersonFormBR;

// *******************************************************************************
// HELPERS
// *******************************************************************************
